import React, { useState, useEffect } from 'react'
import { ReactComponent as HamBurgerMenuIcon } from "../../../design-system/design_system/assets/icons/system/menu.svg";
import MobileSubMenu from "../header/NonDesktopSubmenu";
import {ReactComponent as CloseIcon} from "../../../design-system/design_system/assets/icons/components/notifications/close.svg";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { menuOverlay, setMobileOverlayDisplay, setMobileMenuState } from "../../actions/HeaderActions";
import NonDestopMyAccount from "./MyAccountMenu/NonDestopMyAccount";
import { useMediaQuery } from 'react-responsive';
const NonDesktopMenu = (props) => {
    const [showMobileSubMenu, setShowMobileSubMenu] = useState(false);
    const { setMobileMenuStateFunc, deviceWidth, showMobileOverlay,
        setMobileOverlayDisplayFunc, MobileMenuState, arpBannerData, $mainMenuText } = props;
        const isDesktopOrIpadLandscape = useMediaQuery({
            query: '(min-width: 1024px)'
          })
    useEffect(() => {
        if (MobileMenuState === "NOTIFICATION") {
            setShowMobileSubMenu(true);
        }
    }, [showMobileSubMenu, props])
    const slideMobileMenuConatiner = () => {
        setShowMobileSubMenu(true);
        setMobileMenuStateFunc("ALL")
        setMobileOverlayDisplayFunc(true);
    }

    const closeMobileMenuConatiner = () => {
        setShowMobileSubMenu(false);
        setMobileMenuStateFunc("ALL")
        setMobileOverlayDisplayFunc(false);
    }
    return (
        <>
            {!showMobileSubMenu ? <a href="#" onClick={slideMobileMenuConatiner} className="HamBurgerMenuDisplay d-lg-none">
                <HamBurgerMenuIcon className="svg-fill-black" alt="menu icon" width="42px" height="42px" /></a> : null}
            <div role="menu" className={`sub-menu-container-mobile ${showMobileSubMenu ? "slide-in" : ""}`}>
               {deviceWidth < 1024 && 
               deviceWidth > 767
               &&
               <button className="menu-close-icon" onClick={closeMobileMenuConatiner}>
                    <CloseIcon width="18px" height="18px" />
                </button>   
               } 
               <button className='close-myAccount' onClick={closeMobileMenuConatiner} data-testid="my-account-AX-close-icon">
                    <CloseIcon width="18px" height="18px" />
                </button>
               {
                   !isDesktopOrIpadLandscape &&
                   <NonDestopMyAccount 
                   showMobileSubMenu={showMobileSubMenu}
                   closeMobileMenuConatiner={closeMobileMenuConatiner}
                   deviceWidth={deviceWidth}
                   showMobileOverlay={showMobileOverlay}
                   arpBannerData = {arpBannerData} 
                   MainMenuText = {$mainMenuText}
                  />
               }
                
                {(showMobileOverlay || MobileMenuState === "NOTIFICATION") &&
                    <div className={`bg-black opacity-25 mobile-overlay-container`} onClick={closeMobileMenuConatiner}></div>}
            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        showMobileOverlay: state.CommonReducer.showMobileOverlay,
        showOverlay: state.CommonReducer.showOverlay,
        MobileMenuState: state.CommonReducer.menuState
    }

}
const mapDispatchToProps = (dispatch) => bindActionCreators({
    menuOverlayfunc: menuOverlay,
    setMobileOverlayDisplayFunc: setMobileOverlayDisplay,
    setMobileMenuStateFunc: setMobileMenuState
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(NonDesktopMenu);
